export const MAX_DOWNLOAD_COUNT_LIMIT = 10;
